export default function initAddressAutocomplete(config) {
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    const input = document.querySelector(config.search);
    if (!input) return;

    // Keep Google's suggestion list inside a top-layer dialog when requested.
    const existingMenus = new Set(document.querySelectorAll('.pac-container'));
    const moveMenu = () => {
        const menu = Array.from(document.querySelectorAll('.pac-container')).find(item => !existingMenus.has(item));
        if (menu && config.suggestionContainer) {
            config.suggestionContainer.append(menu);
            menu.classList.add('cg-pdp-flow-v2__address-suggestions');
            menuObserver.disconnect();
        }
    };
    const menuObserver = new MutationObserver(moveMenu);
    if (config.suggestionContainer) menuObserver.observe(document.body, { childList: true, subtree: true });

    const autocomplete = new window.google.maps.places.Autocomplete(input, {
        types: ['address'],
        componentRestrictions: { country: ['us', 'ca'] },
        fields: ['address_components', 'formatted_address'],
    });
    moveMenu();

    autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        let streetNumber = '';
        let route = '';
        let city = '';
        let stateShort = '';
        let stateLong = '';
        let zip = '';
        let zipSuffix = '';
        let country = '';

        place.address_components.forEach((component) => {
            const types = component.types || [];

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            }

            if (types.includes('route')) {
                route = component.long_name;
            }

            if (types.includes('locality')) {
                city = component.long_name;
            }

            if (types.includes('postal_town') && !city) {
                city = component.long_name;
            }

            if (types.includes('administrative_area_level_1')) {
                stateShort = component.short_name;
                stateLong = component.long_name;
            }

            if (types.includes('postal_code')) {
                zip = component.long_name;
            }

            if (types.includes('postal_code_suffix')) {
                zipSuffix = component.long_name;
            }
            if (types.includes('country')) country = component.long_name;


        });

        const fullZip = zipSuffix ? `${zip}-${zipSuffix}` : zip;
        const address1Value = `${streetNumber} ${route}`.trim();

        const address1Field = document.querySelector(config.address1);
        const cityField = document.querySelector(config.city);
        const stateField = document.querySelector(config.state);
        const zipField = document.querySelector(config.zip);


        const countryField = config.country ? document.querySelector(config.country) : null;
        if (countryField && country) setSelectOrInputValue(countryField, country, country);

        if (address1Field) {
            address1Field.value = address1Value;
            address1Field.dispatchEvent(new Event('input', { bubbles: true }));
            address1Field.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (cityField) {
            cityField.value = city;
            cityField.dispatchEvent(new Event('input', { bubbles: true }));
            cityField.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (zipField) {
            zipField.value = fullZip;
            zipField.dispatchEvent(new Event('input', { bubbles: true }));
            zipField.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (stateField && (stateLong || stateShort)) {
            setSelectOrInputValue(stateField, config.preferStateCode ? stateShort : stateLong, stateShort);
        }
        config.onSelect?.();

    });
    return autocomplete;
}

function setSelectOrInputValue(field, primaryValue, secondaryValue) {
    const tag = field.tagName.toLowerCase();

    if (tag === 'select') {
        const options = Array.from(field.options);
        const normalize = (value) => String(value || '').trim().toLowerCase();

        const match =
            options.find((opt) => normalize(opt.value) === normalize(primaryValue)) ||
            options.find((opt) => normalize(opt.text) === normalize(primaryValue)) ||
            options.find((opt) => normalize(opt.value) === normalize(secondaryValue)) ||
            options.find((opt) => normalize(opt.text) === normalize(secondaryValue));

        if (match) {
            field.value = match.value;
            field.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return;
    }

    field.value = primaryValue || secondaryValue || '';
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
}
